export default {"src":"/_next/static/media/intro.642f9350.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};